<template>
    <!--<div class="header-list fixed mt-12 h-28 laptop:h-14 w-full shadow-md flex items-center justify-evenly z-30 bg-theme-white">-->
    <div
        class="header-list sticky top-12 h-14 w-full shadow-md flex items-center justify-evenly z-30 bg-theme-white min-w-min overflow-x-auto">
        <!--<ul class="flex justify-evenly align-middle text-center flex-wrap w-660 laptop:w-full">-->
        <!--    <li class="w-73 desktop:w-20 flex justify-center items-center mx-auto mx-2 my-2 desktop:my-0" v-for="link in links" :key="link.id">-->
        <!--<a class="text-2xs desktop:tex-xs font-bold h-full w-full flex items-center justify-center border-b-2 rounded-sm hover:text-txt-white transition uration-300" :class="link.class" href="">{{ link.name}}</a>-->
        <!--<router-link :to="{name:'Category',query:{category_name:link.id}}" class="text-2xs desktop:tex-xs font-bold h-full w-full flex items-center justify-center border-b-2 rounded-sm hover:text-txt-white transition uration-300" :class="link.class" @click="getParam" >{{ link.name}}</router-link>-->
        <!--        <router-link :to="{name:'Category',query:{operationtype:'category',webcat_view:link.id}}" class="text-2xs desktop:tex-xs font-bold h-full w-full flex items-center justify-center border-b-2 rounded-sm hover:text-txt-white transition uration-300" :class="link.class" @click="getParam" >{{ link.name}}</router-link>-->

        <!--    </li>-->
        <!--</ul>-->
        <ul class="flex justify-evenly align-middle text-center w-1280">
            <li class="w-73 flex justify-center items-center mx-auto mx-2 my-2" v-for="link in links" :key="link.id">
                <!--<a class="text-2xs desktop:tex-xs font-bold h-full w-full flex items-center justify-center border-b-2 rounded-sm hover:text-txt-white transition uration-300" :class="link.class" href="">{{ link.name}}</a>-->
                <!--<router-link :to="{name:'Category',query:{category_name:link.id}}" class="text-2xs desktop:tex-xs font-bold h-full w-full flex items-center justify-center border-b-2 rounded-sm hover:text-txt-white transition uration-300" :class="link.class" @click="getParam" >{{ link.name}}</router-link>-->
                <router-link :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: link.id } }"
                    class="text-2xs desktop:tex-xs font-bold h-full w-full flex items-center justify-center border-b-2 rounded-sm hover:text-txt-white transition uration-300"
                    :class="link.class" @click="getParam">{{ link.name }}</router-link>

            </li>
        </ul>
    </div>
</template>

<script>
// import { ref } from 'vue'
// import { useRoute } from 'vue-router'
export default {
    name: 'headerlist',
    setup() {
        const links = [
            { id: 'Outlet', name: '　アウトレット　セール', class: 'border-theme-Outlet hover:bg-theme-Outlet' },
            { id: 'Desk', name: '　　デスク・　　デスク周辺', class: 'border-theme-Desk hover:bg-theme-Desk' },
            { id: 'Chair', name: 'チェア', class: 'border-theme-Chair hover:bg-theme-Chair' },
            { id: 'Storage', name: '収納', class: 'border-theme-Storage hover:bg-theme-Storage' },
            { id: 'Partition', name: 'パーティション', class: 'border-theme-Partition hover:bg-theme-Partition' },
            { id: 'Counter', name: 'カウンター', class: 'border-theme-Counter hover:bg-theme-Counter' },
            { id: 'Table', name: 'テーブル', class: 'border-theme-Table hover:bg-theme-Table' },
            { id: 'MeetingChair', name: '　ミーティング　チェア', class: 'border-theme-MeetingChair hover:bg-theme-MeetingChair' },
            { id: 'Lobby', name: '応接・ロビー', class: 'border-theme-Lobby hover:bg-theme-Lobby' },
            { id: 'Board', name: 'ボード', class: 'border-theme-Board hover:bg-theme-Board' },
            { id: 'Education', name: '教育・保育施設', class: 'border-theme-Education hover:bg-theme-Education' },
            { id: 'Medical', name: '医療・福祉施設', class: 'border-theme-Medical hover:bg-theme-Medical' },
            { id: 'Accessory', name: 'アクセサリー', class: 'border-theme-Accessory hover:bg-theme-Accessory' },
            // { id: 'Prevention', name: '感染対策用品', class: 'border-theme-Prevention hover:bg-theme-Prevention' },
            // { id: 'Emergency', name: '防災用品', class: 'border-theme-Emergency hover:bg-theme-Emergency' },

        ]

        return {
            links,
        }
    },

}

</script>